import React from "react";
import {
    IProtocolStep,
    IProtocolStepKind,
    IGroupStep,
    TProtocolStepId,
} from "../../types/protocol";
import cx from "clsx";
import classes from "./StepContentView.module.css"
import {useProtocolStore} from "../../store/protocols";
import {IEvent, TEventId, TSubjectId} from "@/common/types";
import {RecorderGroupStepsView} from "./RecorderGroupStepsView";
import {RecorderStepView} from "./RecorderStepView.tsx";
import {DeepPartial} from "@/utils/types/DeepPartial";
import {IProtocolStepEvent} from "@/protocols/types/IProtocolStepEvent.ts";
import {Box} from "@mantine/core";
import {Dayjs} from "dayjs";

interface StepContentViewProps {
    subjectId: TSubjectId
    step: IProtocolStep
    protocolStepEvents: Record<TProtocolStepId, Array<IEvent>>
    onDeleteEvent: (id: TEventId) => void
    allSteps?: Array<IProtocolStep>
    onChange: (stepId: TProtocolStepId, updates: DeepPartial<IProtocolStep>) => void
    selectedStep: IProtocolStep
    onStepSelected: (stepId: TProtocolStepId) => void
    sessionStartTime?: Dayjs
    /**
     * Single creation hook forwarded to the rendered RecorderStepView
     * (or RecorderGroupStepsView, which forwards to its members). The
     * caller decides how to persist (pending-writes, direct, etc).
     */
    createEvent?: (
        eventData: IProtocolStepEvent,
    ) => Promise<IProtocolStepEvent>
}

export const StepContentView: React.FC<StepContentViewProps> = ({
                                                                    subjectId,
                                                                    step,
                                                                    protocolStepEvents,
                                                                    onDeleteEvent,
                                                                    allSteps = [],
                                                                    onChange,
                                                                    selectedStep,
                                                                    onStepSelected,
                                                                    createEvent,
                                                                }: StepContentViewProps) => {
    const timezone = useProtocolStore((state) => state.timezone)

    if (step.kind === IProtocolStepKind.GROUP) {
        const groupStep = step as IGroupStep;
        return (
            <div className={cx(classes.root)}>
                <RecorderGroupStepsView
                    group={groupStep}
                    allSteps={allSteps}
                    subjectId={subjectId}
                    protocolStepEvents={protocolStepEvents}
                    onDeleteEvent={onDeleteEvent}
                    timezone={timezone}
                    onStepChange={(stepId, updates) => onChange(stepId, updates)}
                    style={{flex: 1, minHeight: 0}}
                    selectedStep={selectedStep}
                    onStepSelected={onStepSelected}
                    createEvent={createEvent}
                />
            </div>
        );
    }

    const stepIndex = allSteps.findIndex(s => s.id === step.id);

    return (
        <Box className={cx(classes.root)}>
            <RecorderStepView
                key={step.id}
                step={step}
                index={stepIndex >= 0 ? stepIndex : 0}
                subjectId={subjectId}
                protocolStepEvents={protocolStepEvents}
                onDeleteEvent={onDeleteEvent}
                timezone={timezone}
                onChange={(updates) => onChange(step.id, updates)}
                createEvent={createEvent}
            />
        </Box>
    )
}